import { jsx } from "react/jsx-runtime";
import { Highlight } from "./Highlight.js";
function Token(props) {
  const { text, match, classes } = props;
  if (match) {
    return /* @__PURE__ */ jsx(Highlight, { className: classes.highlight, children: text });
  }
  return /* @__PURE__ */ jsx("span", { children: text });
}
export {
  Token
};
//# sourceMappingURL=Token.js.map
